"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";
import { RxChevronRight } from "react-icons/rx";
import { motion } from "framer-motion";

export function PersonalIntroduction() {
  const scrollToImplementationProcess = () => {
    // Store the target section in sessionStorage
    sessionStorage.setItem('scrollTarget', 'implementation-process');
    window.location.href = '/services';
  };

  const scrollToCaseStudies = () => {
    document.getElementById('case-studies')?.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'start' 
    });
  };

  return (
    <section id="personal-intro" className="px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container">
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-x-12 md:gap-y-8 lg:gap-x-20">
          <div>
            <motion.h2 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="inline-flex items-center rounded-full bg-blue-400/10 px-4 py-1.5 text-sm font-medium text-blue-400 ring-1 ring-inset ring-blue-400/20 mb-4"
            >
              Why Omnigeist
            </motion.h2>
            <h2 className="mb-5 text-4xl font-bold md:mb-6 md:text-5xl lg:text-6xl bg-gradient-to-br from-white to-gray-400 bg-clip-text text-transparent">
              Building the Future of Storytelling
            </h2>
          </div>
          <div>
            <p className="md:text-md">
              After nearly three decades as a developer, architect, and technical leader,
              I envisioned a platform that would revolutionize how we create and share
              stories. Omnigeist combines my passion for innovative technology with the
              limitless possibilities of AI-augmented development, creating a unique
              approach to narrative universe creation.
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-4 md:mt-8">
              <Button 
                title="View Our Approach" 
                variant="secondary"
                onClick={scrollToImplementationProcess}
              >
                View Our Approach
              </Button>
              <Button
                title="Case Studies"
                variant="link"
                size="link"
                iconRight={<RxChevronRight />}
                onClick={scrollToCaseStudies}
              >
                Case Studies
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}